<script>
import {h, resolveComponent} from 'vue';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';

import {CHART} from '@/components/constants/chart';
import widgetWrapper from '@/components/widgets/common/widgetWrapper';
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  name: 'widgetChartMultiBar',
  emits: ['click', 'more'],
  mixins: [i18nMixin],
  components: {widgetWrapper, 'v-chart': ECharts},
  render() {
    const {items} = this;
    const {title, subtitle, dateItem, more, info} = items;
    const legoIcon = resolveComponent('lego-icon');
    const cLabel = resolveComponent('c-label');
    const vChart = resolveComponent('v-chart');
    const widgetWrapper = resolveComponent('widget-wrapper');

    const nullWidget = h('div', {class: ['widget-null']}, [
      h(legoIcon, {
        iconType: 'df',
        icon: 'exclamation_circle',
        size: 72,
        color: '#D6DCF4'
      }),
      h(
          cLabel,
          {
            size: 20,
            weight: 500
          },
          () => [this.t('label.noData')]
      )
    ]);

    const widgetChartBar =
        items.data.length > 0
            ? h(vChart, {
              autoresize: true,
              option: this.buildOption(),
              style: [{width: '100%', height: '100%'}],
              onClick: (item) => {
                this.$emit('click', item);
              }
            })
            : nullWidget;

    return h(
        widgetWrapper,
        {
          title,
          subtitle,
          dateItem,
          more,
          info,
          onMore: (more) => {
            this.$emit('more', more);
          }
        },
        () => [widgetChartBar]
    );
  },
  props: {
    items: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    buildOption() {
      const {$theme, items} = this;

      const series = this.items.data.map((seriesData, idx) => ({
        value: seriesData,
        name: items.xAxisData[idx],
        itemStyle: {color: $theme.COLOR.CHART[idx]}
      }));

      const option = {
        title: {
          subtext: this.items.unit
        },
        xAxis: [
          {
            data: items.xAxisData,
            axisLabel: {
              formatter: function (value) {
                if (this.items.data.length > 4) {
                  return value.length > 5 ? value.slice(0, 5) + '...' : value;
                } else {
                  return value.length > 9 ? value.slice(0, 9) + '...' : value;
                }
              }.bind(this)
            }
          }
        ],
        series: {data: series}
      };

      return _.merge({}, CHART.CHART_BAR, option);
    }
  }
};
</script>

<style scoped lang="scss">
.widget-chart-bar {
  height: 100%;
  margin: 0 auto;
  padding: 20px;
}

.widget-null {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 100%;

  :deep.lego-icon {
    margin-bottom: 17px;
  }
}
</style>
